import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutDashboard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"layout-dashboard, grid, window"} maskId="square-filled-radius-0-stroke-1-IconLayoutDashboard"><path d="M3 9V3H11.5V9H3Z" fill="currentColor"/><path d="M3 10V21L11.5 21V10H3Z" fill="currentColor"/><path d="M12.5 21L21 21V15H12.5V21Z" fill="currentColor"/><path d="M21 14V3H12.5V14H21Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLayoutDashboard;
